import sparkGenericDefaults from '../shopify-spark-generic/config.js';

const cultureCode = window.Shopify?.routes?.root.slice(0, -1) ?? '';

const baseFitmentFields = sparkGenericDefaults.fitmentSearch.baseFields;

export default {
  includes: ['shopify-spark-generic'],
  ...sparkGenericDefaults,
  searchPageUrl: `${cultureCode}/search`,
  Widgets: [
    ...sparkGenericDefaults.Widgets.filter(
      (w) => !['HeaderVehicleWidget', 'FacetBrandTiles'].includes(w.name),
    ),

    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/homeVehicleWidget',
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
      columnBreakpoint: 1000,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      view: 'columns',
      isVehicleWidgetDisabled: !!window.document.querySelector('#cm-ymm'),
    },
  ],
};
